<template>
	<div>
		<div class="search2">
			<div class="search2-main">
				<input type="text" class="search2-input" placeholder="请输入搜索内容" @keypress="enterPress" @input="input" v-model="keyword"/>
				<div class="search2-button" @click="replaceToSearch()"></div>
			</div>
			<div class="search2-content">
				<div class="search2-keyword" v-if="!isSearch">
					<div class="search2-keyword-title f-cb">
						<div class="search2-keyword-title-name">搜索历史</div>
						<div class="search2-keyword-title-clear" @click="clearHistory">清空</div>
					</div>
					<div class="search2-keyword-empty" v-if="searchList.length==0">无搜索历史</div>
					<ul class="search2-keyword-items f-cb" v-else>
						<!--<li class="search2-keyword-item">历史文化</li>-->
						<li class="search2-keyword-item" v-for="item in searchList" @click="replaceToSearch(item)">{{item}}</li>
					</ul>
				</div>
				<template v-else>
					<div class="search2-warn" v-if="data==null">搜索中</div>
					<ul class="lesson2-items" v-else-if="data.length>0">
						<li class="lesson2-item" v-for="(item,index) in data" @click="$router.push('/lesson-detail/'+item.id)">
							<div class="lesson2-main">
								<div class="lesson2-pic f-img-box">
									<img :src="item.cover_img">
								</div>
								<div class="lesson2-content">
									<div class="lesson2-name o1" v-if="item.course_teachers[0]" v-text="item.course_teachers[0].nick_name"></div>
								</div>
							</div>
							<div class="lesson2-text o1" v-text="item.course_title"></div>
						</li>
						<li class="lesson2-item lesson2-item-empty"></li>
					</ul>
					<div class="search2-warn empty-img" v-else>
            <img src="./nosearch.png"/>
            <p>未搜索到相关内容</p>
          </div>
				</template>

				<!--<div class="search2-keyword">
					<div class="search2-keyword-title f-cb">
						<div class="search2-keyword-title-name">热门搜索</div>
					</div>
					<ul class="search2-keyword-items f-cb">
						<li class="search2-keyword-item">历史文化</li>
						<li class="search2-keyword-item">长一些的关键字</li>
						<li class="search2-keyword-item">长一些wwee的关键字</li>
						<li class="search2-keyword-item">长一些的关键字</li>
						<li class="search2-keyword-item">长一些的关键字</li>
					</ul>
				</div>-->
			</div>
			<!--<div class="search-related">
				<div class="search-related-title">相关内容</div>
				<ul class="search-related-items">
					<li class="search-related-item o1">走走进走进进中国<span>文化</span>之门</li>
					<li class="search-related-item o1">走走进走进进进进进进进进进进进进进进进进进进进进进进中国<span>文化</span>之门</li>
				</ul>
			</div>-->
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				searchList:[],
				isSearch:false,
				data:null,
				keyword:""
			}
		},
		created(){
		  //获取查询历史
			var searchList=localStorage.getItem("searchList");
			if(searchList){
				this.searchList=searchList.split(",");
			}

			//如果url带有keyword，做查询
      this.keyword=this.$route.params.keyword;
      if(this.keyword){
			  this.search(this.keyword);
      }
		},
		mounted(){
			document.querySelector(".search2-input").focus();
		},
		methods:{
			clearHistory(){
				localStorage.setItem("searchList","");
				this.searchList=[];
			},
			enterPress(evt){
				if(evt.keyCode==13){
					this.replaceToSearch(evt.target.value);
				}
			},
			replaceToSearch(keyword){
				if(!keyword) keyword=this.keyword;
				this.$router.replace("/search/"+keyword);
			},
			input(evt){
				if(evt.target.value==""){
					this.isSearch=false;
				}
			},
			search(keyword){
				if(!keyword) return;
				this.isSearch=true;
				this.data=null;
				//将查询记录保存到本地
				var saveList;
				if(localStorage.hasOwnProperty("searchList") && localStorage.getItem("searchList")!=""){
					saveList=localStorage.getItem("searchList").split(",");
				}
				else{
					saveList=[];
				}
				saveList=saveList.filter((value,index)=>{
					if(keyword==value){
						return false;
					}
					return true;
				})
				this.searchList=this.searchList.filter((value,index)=>{
					if(keyword==value){
						return false;
					}
					return true;
				})
				saveList.push(keyword);
				this.searchList.push(keyword);
				localStorage.setItem("searchList",saveList);
				//开始查询
				this.$api.get("",{
					api:"/v1/search/index",
					title:keyword
				},res=>{
					this.data=res.data.list;
				})
			}
		},
		watch:{
		  //url中的keyword改变时做查询
			$route(){
				var keyword=this.$route.params.keyword;
				if(keyword){
					this.search(keyword);
					this.keyword=keyword;
				}
				else{
					this.isSearch=false;
				}
			}
		}
	}
</script>

<style>
	.search2{
		height:0.96rem;
		padding-top:0.213rem;
		background: #fff;
	}
	.search2-main{
		margin:0 auto;
		width:9.2rem;
		height:0.773rem;
		border-bottom: 1px solid #e6e6e6;
	}
	.search2-input{
		height:0.773rem;
		margin-left:0.266rem;
		width:8rem;
		border:0;
		font-size: 0.453rem;
		color:#999;
	}
	.search2-button{
		float:right;
		width:0.6rem;
		height:0.77rem;
		background:url(./search.png) center right no-repeat;
		background-size: 0.48rem;
	}
	.search2-keyword{
		padding:0 0.4rem;
		margin-top:0.533rem;
		font-size: 0.32rem;
		line-height:0.32rem;
	}
	.search2-keyword-title-name{
		float:left;
		color:#999;
	}
	.search2-keyword-title-clear{
		float:right;
		color:#3192E0;
	}
	.search2-keyword-items{
		padding-top:0.133rem;
		margin-right:-0.266rem;
	}
	.search2-keyword-item{
		float:left;
		margin-top:0.266rem;
		margin-right:0.266rem;
		padding:0 0.32rem;
		height:0.613rem;
		border:1px solid #ccc;
		text-align: center;
		line-height:0.613rem;
		border-radius: 0.346rem;
		font-size: 0.32rem;
		color:#999;
	}
	.search2-keyword-empty{
		margin-top:0.4rem;
		font-size: 0.32rem;
	}
	.search2-warn{
		margin-top:0.4rem;
		height:0.533rem;
		line-height: 0.533rem;
		font-size: 0.346rem;
		text-align: center;
	}
	.search-related{
		padding:0.533rem 0.4rem 0 0.4rem;
	}
	.search-related-title{
		font-size: 0.426rem;
		color:#999;
		line-height:0.426rem;
	}
	.search-related-items{
		margin-top:0.146rem;
	}
	.search-related-item{
		font-size: 0.426rem;
		line-height:1.2rem;
		color:#333;
	}
	.search-related-item span{
		color:#EC6D3A;
	}
</style>



// WEBPACK FOOTER //
// src/components/search/search.vue